import * as React from 'react';
import { Container, Section, Title, Tabs } from '../../modules/modules';
import CountryService from '../../services/CountryService';
import ProductFile from '../ProductFile';

export interface IProductInfoProps {
  product: GQL.IProduct;
  variant: GQL.IProductVariant;
}

function createMarkup(content: string) {
  return { __html: '<p>' + content !== null && content !== undefined 
    ? content.replace(/(?:\r\n|\r|\n)/g, '</p><p>') 
    : '' + '</p>' };
}

class ProductInfo extends React.Component<IProductInfoProps> {

  public render() {
    const { language } = CountryService.GetInstance();
    const { product } = this.props;

    const hasTechnicals = (product.technicalSpecification[language] 
      && product.technicalSpecification[language] != product.description[language]);

    const tabs = ['Information'];
    if (hasTechnicals) {
      tabs.push('Technical specification');
    }
    if (product.videos && product.videos.length > 0) {
      tabs.push('Video');
    }

    return (
      <div className="productInfo">
        <Section type="product-info">
          <Container>

            <Tabs type="red" tabs={tabs}>
              <div className="tab__item">
                <Title type="center">Information</Title>
                <Title type="sub">{product.name[language]}</Title>

                {product.description[language] && 
                  <div dangerouslySetInnerHTML={createMarkup(product.description[language])} />}

                {product.files && product.files.length > 0 &&
                  <div className="productInfo__files">
                    <Title type="download">Download</Title>
                    {product.files && product.files.map((file: GQL.IProductFile) => (
                      <ProductFile file={file} key={file.id} />
                    ))}
                  </div>}
              </div>

              {hasTechnicals ?
                <div className="tab__item">
                  <Title type="center">Technical specification</Title>
                  <Title type="sub">{product.name[language]}</Title>

                  <div dangerouslySetInnerHTML={createMarkup(product.technicalSpecification[language])} />
                </div> : null}

              {product.videos && product.videos.length > 0 && 
                <div className="tab__item">
                  <Title type="center">Video</Title>
                  <Title type="sub">{product.name[language]}</Title>

                  <div className="productInfo__videos cf">
                    {product.videos && product.videos.map((video: GQL.IProductVideo) => (
                      <div className="video" key={video.id}>
                        <iframe 
                          style={{ width: '100%', height: '100%' }}
                          src={video.url} 
                          frameBorder="0" 
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                          allowFullScreen={true} 
                        />
                      </div>
                    ))}
                  </div>
                </div>}
                
            </Tabs>

          </Container>
        </Section>
      </div>
    );
  }
}

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/components/ProductInfo/ProductInfo.tsx